import type { AuthService } from "@storytell/auth";
import type { DeviceService } from "@storytell/device";
import type { EnvironmentConfig } from "@storytell/environment";
import type { LocaleService } from "@storytell/locale";
import type { Logger } from "@storytell/logger";
import { Noop as NoopLogger } from "@storytell/logger";
import type { StreamingService } from "@storytell/streaming";
import type { BillingService } from "~/stores/billing";
import type { ChatService } from "~/stores/chat/chatService";
import type { GuidesService } from "~/stores/guides/guidesService";
import type { KnowledgeUIService } from "~/stores/knowledge/knowledgeUIService";
import type { createSyncService } from "~/stores/sync/createSyncService";
import type { UIStore } from "~/stores/uiService";
import type { ChatTitleService } from "./services/chatTitleService";

// Wire provides access to dependencies, global state, and the ability to
// interact with domains/business-logic.
export interface Wire {
  auth: AuthService;
  sync: ReturnType<typeof createSyncService>;
  device: DeviceService;
  chat: ChatService;
  chatTitle: ChatTitleService;
  guides: GuidesService;
  stream: StreamingService;
  billing: BillingService;
  environment: EnvironmentConfig;
  locale: LocaleService;
  logger: Logger;
  ui: UIStore;
  knowledgeUi: KnowledgeUIService;
}

/** defaultWire signals that the wire is not yet initialized. */
export const defaultWire: Wire = Object.freeze({
  auth: {} as AuthService,
  ui: {} as UIStore,
  sync: {} as ReturnType<typeof createSyncService>,
  // sync: {} as SyncService,
  chat: {} as ChatService,
  chatTitle: {} as ChatTitleService,
  billing: {} as BillingService,
  guides: {} as GuidesService,
  stream: {} as StreamingService,
  device: {} as DeviceService,
  knowledgeUi: {} as KnowledgeUIService,
  locale: {} as LocaleService,
  environment: {} as EnvironmentConfig,
  logger: new NoopLogger("_"),
});
